import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from "../../../components/DataTable/DataTable";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemRevisionModel from "../../../models/ItemRevisionModel";
import ItemReferenceModel from "../../../models/ItemReferenceModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ExportModel {
    itemId: number
    itemReferences: ItemReferenceModel[]
}
interface IProps extends PopupProps {
    itemRevision: ItemRevisionModel
}

const ExportItemPopup: React.FC<IProps> = ({ show, onHide, itemRevision }) => {
    const { handleResult, handleException } = useNotifications();
    const [data, setData] = useState<ExportModel>();

    useEffect(() => {
        getData()
    }, [itemRevision]);

    function getData() {
        if (itemRevision) {
            DataService.get<ItemReferenceModel[]>('api/v1/ItemReferences/ByItemForExport/' + itemRevision.itemId)
                .then(response => {
                    setData({
                        itemId: itemRevision.itemId,
                        itemReferences: response
                    })
                })
        }
    }

    function submit() {
        if (data) {
            data.itemReferences = data.itemReferences.filter(x => x['_checkbox_export'] === true)
            DataService
                .post<Result>(`api/v1/ItemReferences/export`, data)
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true)
                        onHide();
                    else
                        getData();
                })
                .catch(e => handleException(e));
        }
    }

    function selectAllRows(selectedRows: any[]) {
        if (data) {
            if (selectedRows.length != data.itemReferences.length)
                data.itemReferences.forEach(r => r['_checkbox_export'] = true)
            else
                data.itemReferences.forEach(r => r['_checkbox_export'] = false)

            setData(x => ({ ...data }))
        }
    }


    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Export item'} >
            <Popup.Body>
                {data && (
                    <DataTable
                        name='dtitemExport'
                        colInfos={[
                            { key: true, dataProp: 'id', visible: false },
                            { checkboxButton: { icon: 'fa-check', color: 'green', text: 'export', onClick: (selectedRows) => { selectAllRows(selectedRows); } } },
                            { title: 'External System', dataProp: 'externalSystemName' },
                            { title: 'Size', dataProp: 'sizeName' },
                            { title: 'Reference code', dataProp: 'referenceCode' },
                            { title: 'Ready on', dataProp: 'readyForExportOn', dataType: 'datetime' },
                            { title: 'Exported on', dataProp: 'exportedOn', dataType: 'datetime' },
                        ]}
                        tableData={data.itemReferences}
                    />
                )}
            </Popup.Body>
            <Popup.Footer>
                <Button text="Export" type='button' onClick={submit} />
            </Popup.Footer>
        </Popup>
    );
}
export default ExportItemPopup;